module.exports = __webpack_public_path__ + "img/mb-who-are-we-pic2.abf2b743.png";